<div class="file-status-renderer">
  <span class="file-status-renderer__text" [title]="status">{{ status }}</span>
  <app-popover-info-icon
    *ngIf="showHelpText"
    class="file-status-renderer__help"
    [helpText]="helpText"
    [compact]="true"
    popoverPlacement="top">
  </app-popover-info-icon>
</div>
